import { createContext, useCallback, useContext, useEffect, useRef, useState, type ReactNode } from 'react';

const DURATION = 2200;

const ToastContext = createContext<(message: string) => void>(() => {});

/** One toast at a time, bottom-centre above the dock; a new one replaces the old. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState<{ text: string; n: number } | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const show = useCallback((text: string) => {
    setMsg((m) => ({ text, n: (m?.n ?? 0) + 1 }));
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setMsg(null), DURATION);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);
  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className="toast" role="status" aria-live="polite" hidden={!msg}>
        {msg?.text}
      </div>
    </ToastContext.Provider>
  );
}

/** `const toast = useToast(); toast('Got it, thanks')` */
export function useToast() {
  return useContext(ToastContext);
}
